<template>
  <v-container fluid>
    <v-dialog v-model="edit" max-width="500px">
      <ValidationObserver ref="observer" v-slot="{ validate, reset }">
        <v-card>
          <v-card-title>
            <v-title>
              <span class="headline">Edit</span>
            </v-title>
          </v-card-title>
          <v-card-text>
            <dealer-details :editedItem="editedItem"></dealer-details>
            <message-alert :component="message"></message-alert>
          </v-card-text>
          <v-card-actions>
            <div v-if="!adding">
              <v-btn color="red" @click.native="deleteInterest" :disabled="!showRejected">Delete</v-btn>
              <v-btn icon @click.native="approveInterest" :disabled="deleteEditedItem">
                <v-icon title="Approve" color="teal">thumb_up_alt</v-icon>
              </v-btn>
              <v-btn icon @click.native="rejectInterest" :disabled="editedItem.rejected">
                <v-icon title="Reject" color="pink">thumb_down_alt</v-icon>
              </v-btn>
            </div>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="save()">Save</v-btn>
            <v-btn color="light-grey" @click.native="edit = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
    

    <v-dialog v-model="add" max-width="500px">
      <ValidationObserver ref="observer" v-slot="{ validate, reset }">
        <v-card>
          <v-card-title>
            <v-title>
              <span class="headline">Add New Interested Dealer</span>
            </v-title>
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-text-field label="Full Name" v-model="editedItem.dealerName"></v-text-field>
            </v-flex>
            <v-flex xs12>
                <ValidationProvider v-slot="{ errors }" name="Email" rules="email|required">
                  <v-text-field
                    label="Email"
                    v-model="editedItem.email"
                    data-vv-as="Email"
                    name="item_email"
                    data-vv-validate-on="change"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
            <message-alert :component="message"></message-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="sendContract()">Send Dealer Contract</v-btn>
            <v-btn color="light-grey" @click.native="add = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
    
    <v-dialog v-model="approve" max-width="500px"></v-dialog>
    <v-title>Vonex Online Dealer Registration Form</v-title>
    <salesforce-leads @adding="newSalesforceInterest"></salesforce-leads>
    <v-dialog v-model="report" full-width>
      <v-btn slot="activator" color="primary">Interested Dealers Report</v-btn>
      <v-card>
        <v-card-title primary-title>
          <v-title>Interested Dealers Report</v-title>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-xs>
            <ValidationObserver ref="observer" v-slot="{ validate, reset }">
              <v-layout row wrap>
                <v-flex xs6>
                  <label>Start Date for Report</label>
                  <ValidationProvider v-slot="{ errors }">
                    <date-picker
                      lang="en-au"
                      name="endDate"
                      format="DD/MM/YYYY"
                      value-type="YYYY-MM-DD"
                      placeholder="dd/MM/YYYY"
                      v-model="startDate"
                      rules="'required'"
                      editable
                      data-vv-validate-on="blur"
                    />
                  </ValidationProvider>
                </v-flex>
                <v-flex xs6>
                  <label>End Date for Report</label>
                  <ValidationProvider>
                    <date-picker
                      lang="en-au"
                      name="endDate"
                      label="End Date"
                      format="DD/MM/YYYY"
                      value-type="YYYY-MM-DD"
                      placeholder="dd/MM/YYYY"
                      v-model="endDate"
                      rules="'required'"
                      editable
                      data-vv-validate-on="blur"
                    />
                  </ValidationProvider>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    name="email"
                    label="Where to send report"
                    id="email"
                    v-model="email"
                    placeholder="use (;) to separate emails"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-checkbox label="Show Rejected" v-model="showRejected"></v-checkbox>
                </v-flex>
              </v-layout>
            </ValidationObserver>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="sendingDialog = true">Run Report</v-btn>
          <v-btn color="light-grey" @click.native="report = false">Cancel</v-btn>
        </v-card-actions>
        <hr />
        <v-flex xs12 id="report"></v-flex>
      </v-card>

      <v-dialog v-model="sendingDialog" hide-overlay persistent width="300">
        <v-card :color="sendDialogColor" dark>
          <v-card-text>
            {{ this.sendingDialogText }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-dialog>

    <v-layout row wrap>
      <v-flex xs4>
        <v-text-field name="Search" label="Search" v-model="SearchText" append-icon="search"></v-text-field>
        <v-btn color="primary" @click="addNewDealer">Add New Interested Dealer</v-btn>
      </v-flex>
      <v-flex xs8>
        <v-layout row wrap>
          <v-checkbox label="Show Rejected" v-model="showRejected"></v-checkbox>
          <v-checkbox label="Show Approved" v-model="showApproved"></v-checkbox>
          <v-select clearable :items="dealerStatus" v-model="filterStatus" label="Filter Status"></v-select>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :pagination.sync="pagination"
          :items="filteredRows"
          :headers="headers"
          :loading="loading"
          :total-items="total"
          item-key="id"
        >
          <template slot="items" slot-scope="props">
            <td
              v-for="(prop, propIndex) in headers.filter(
                (x) => x.text !== 'Actions'
              )"
              :key="propIndex"
              :class="'ma-0'"
            >
              <div
                v-if="prop.autocomplete"
                :class="'text-xs-' + prop.align"
              >{{ props.item[prop.value][prop.nested] }}</div>

              <div v-else :class="'text-xs-' + prop.align">{{ props.item[prop.value] }}</div>
            </td>
            <td class="justify-center layout px-0">
              <v-btn icon class="mx-0">
                <v-icon
                  title="Edit"
                  color="green"
                  @click="
                    editedItem = Object.assign({}, props.item);
                    editedIndex = props.item['id'];
                    edit = true;
                  "
                >edit</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
      <v-layout row>
        <v-flex xs12>
          <message-alert :component="message"></message-alert>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { httpError } from "@/models/httpError";
import { ReportParameters } from "@/models/dealerPortal/ReportParameters";
import { DealerInterest } from "@/models/dealerPortal/DealerInterest";
import SalesforceLeads from "@/components/dealerportal/salesforce-leads";
import moment from "moment";
import DealerDetails from "./dealer-details";
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapRegisterActions } = createNamespacedHelpers(`register`);

import {
  mapRegisterFields,
  mapRegisterMultiRowFields
} from "@/store/modules/register";
export default {
  name: "dealer-interest",
  components: {
    DealerDetails,
    SalesforceLeads
  },
  data() {
    return {
      adding: false,
      filterStatus: undefined,
      menu: false,
      menu2: false,
      report: false,
      startDate: moment(new Date())
        .toISOString()
        .slice(0, 10),
      endDate: new Date().toISOString().slice(0, 10),
      email: null,
      showRejected: false,
      showApproved: false,
      valid: true,
      reject: false,
      approve: false,
      editedItem: new DealerInterest(),
      editedIndex: 0,
      edit: false,
      add: false,
      SearchText: null,
      items: [],
      sendingDialog: false,
      sendingDialogText: " ",
      showDeleteDialog: false,
      deleteEditedItem: false,
      sendDialogColor: "primary",
      total: 0,
      pagination: {
        page: 1,
        rowsPerPage: 20,
        descending: true
      },
      loading: false,
      headers: [
        {
          text: "ID",
          align: "right",
          sortable: true,
          value: "id"
        },
        {
          text: "Dealer Name",
          align: "left",
          sortable: true,
          value: "dealerName"
        },
        {
          text: "Current Business",
          align: "left",
          sortable: true,
          value: "currentBusiness"
        },

        {
          text: "Email",
          align: "left",
          sortable: true,
          value: "email"
        },
        {
          text: "Mobile",
          align: "left",
          sortable: true,
          value: "mobileNo"
        },

        {
          text: "Approved",
          align: "left",
          sortable: true,
          value: "approved"
        },
        {
          text: "Rejected",
          align: "left",
          sortable: true,
          value: "rejected"
        },
        {
          text: "Status",
          align: "left",
          value: "dealerStatus",
          sortable: true
        },
        {
          text: "Actions",
          value: "name",
          sortable: false
        }
      ]
    };
  },
  methods: {
    ...mapRegisterActions([
      "getInterested",
      "setMessage",
      "saveDealerInterest",
      "approveDealer",
      "approveDealerByID",
      "rejectDealer",
      "listInterested",
      "emailInterested",
      "saveRegistered",
      "createNewDealer",
      "deleteDealerInterest",
      "sendDealerContract"
    ]),
    setEdited(props) {
      this.editedItem = props.item;
      this.approve = true;
      this.editedIndex = props.indexOf(props.item);
    },
    interestedReport() {
      let vm = this;
      var reportParameters = new ReportParameters({
        startDate: vm.startDate,
        endDate: vm.endDate,
        showRejected: vm.showRejected,
        email: vm.email
      });

      vm.listInterested(reportParameters)
        .then(data => {
          document.getElementById("report").innerHTML = data;
          vm.loading = false;
        })
        .catch(() => {
          vm.sendingDialog = false;
        });

      if (vm.email !== null) {
        vm.emailInterested(reportParameters)
          .then(() => {
            this.sendDialogColor = "green";
            this.sendingDialogText = "Report emailed";
            setTimeout(() => (this.sendingDialog = false), 1000);
          })
          .catch(() => {
            this.sendDialogColor = "red";
            this.sendingDialogText = "Error sending email";
            setTimeout(() => (this.sendingDialog = false), 1000);
            this.sendDialogColor = "primary"; //Just for tidiness sake.
          });
      }
      vm.sendingDialog = false;
    },
    openItem: link => {
      if (link.includes("http")) window.open(link, "_blank");
      else window.open("https://www.vonex.com.au/" + link, "_blank");
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    newSalesforceInterest(partners) {
      let vm = this;
      if (!partners) return;

      partners.forEach(async element => {
        let interested = new DealerInterest({
          scheduleDate: new Date(),
          firstName: element.firstName,
          lastName: element.lastName,
          email: element.email,
          address: element.street,
          suburb: element.city,
          mobileNo: element.mobilePhone,
          currentBusiness: element.company,
          postcode: element.postcode,
          approved: false,
          rejected: false,
          fullName: `${element.firstName} ${element.lastName}`,
          salesForceID: element.id,
          approved: true
        });
        // await vm.approveDealer(interested);
      });
    },
    addNewDealer() {
      let vm = this;
      vm.editedItem = new DealerInterest({
        scheduleDate: new Date(),
        approved: false,
        rejected: false
      });
      vm.add = true;
    },
    save() {
      let vm = this;

      const isValid = vm.$refs.observer.validate();
      isValid.then(result => {
        if (result) {
          vm.saveDealerInterest(vm.editedItem)
            .then(() => {
              vm.edit = false;
              vm.adding = false;
              vm.refreshPage();
            })
            .catch(() => {
              vm.adding = false;
              this.close();
            });
        }
      });
    },
    addEntry() {
      this.setMessage(new httpError());
      this.editedIndex = this.addRow();
      this.editedItem = this.rows[this.editedIndex];
    },
    approveInterest() {
      let vm = this;
      vm.edit = false;
      vm.setMessage(new httpError());
      //vm.editedIndex = this.rows.indexOf(vm.editedItem);
      vm.approveDealerByID(vm.editedIndex)
        .then(() => {
          vm.refreshPage();
        })
        .catch(() => {
          vm.refreshPage();
        });
    },
    rejectInterest() {
      let vm = this;
      this.setMessage(new httpError());

      vm.rejectDealer(vm.editedItem.id).then(() => {
        vm.edit = false;
        // vm.refreshPage();
      });
    },
    deleteInterest() {
      let vm = this;
      this.setMessage(new httpError());
      vm.deleteDealerInterest(vm.editedItem).then(() => {
        vm.edit = false;
        vm.refreshPage();
      });
    },
    refreshPage() {
      let vm = this;
      vm.getInterested(vm.showRejected)
        .then(data => {
          vm.items = data;
          vm.total = data.count;
          vm.loading = false;
          //vm.$forceUpdate();
        })
        .catch(() => {});
    },
    isValid: function(item) {
      let vm = this;
      if (vm.SearchText === null) return true;
      let found = false;
      const filters = vm.headers.filter(x => x.sortable).map(x => x.value);
      for (var i = 0; i < filters.length; i++) {
        if (item[filters[i]] !== null) {
          found =
            found ||
            item[filters[i]]
              .toString()
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase());
        }
      }
      return found;
    },
    sendContract() {
      let vm = this;
      if(vm.editedItem.dealerName && vm.editedItem.email) {
        let name = vm.editedItem.dealerName.split(' ');
        vm.sendDealerContract({
          email: vm.editedItem.email,
          firstName: name[0],
          lastName: name[1],
          status: "Approved"
        })
          .then(() => {
            this.close();
          })
      } else {
        vm.setMessage({ message: "Full name and email are required to send dealer contract.", httpStatus: 500 })
      }
    }
  },
  computed: {
    ...mapRegisterFields(["message"]),
    ...mapRegisterMultiRowFields(["rows"]),
    dealerStatus: function() {
      let vm = this;
      return [...new Set(vm.filteredRows.map(x => x.dealerStatus))];
    },
    filteredRows: function() {
      let vm = this;
      return vm.items
        .filter(this.isValid)
        .filter(
          x => x.approved == vm.showApproved && x.rejected == vm.showRejected
        )
        .filter(z =>
          typeof vm.filterStatus !== "undefined"
            ? z.dealerStatus == vm.filterStatus
            : true
        );
    }
  },
  watch: {
    showRejected() {
      this.refreshPage();
    },
    sendingDialog(val) {
      if (!val) return;
      this.sendingDialog = true;
      this.sendingDialogText = "Please wait";
      this.interestedReport();
    }
  },
  mounted() {
    // this.$validator.localize("en", this.dictionary);
    this.refreshPage();
  }
};
</script>

<style scoped></style>
